module.exports = __webpack_public_path__ + "img/surv.67f9eada.jpg";